export const en = {
    title: `Change Password`,
    description: `Update your account password`,
    passwordChanged: `Password changed successfully!`,
    changePasswordButton: `Change Password`,
    changingPassword: `Changing password...`,
    sessionExpired: `Your session has expired. Please log in again.`,
    failure: `Password change failed`,
};
//# sourceMappingURL=en.js.map